/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Eyes_NoteInputs */

const en_funnel_ob_ben_eyes_note = /** @type {(inputs: Funnel_Ob_Ben_Eyes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screen off, audio keeps playing`)
};

const es_funnel_ob_ben_eyes_note = /** @type {(inputs: Funnel_Ob_Ben_Eyes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla apagada, el audio sigue sonando`)
};

/**
* | output |
* | --- |
* | "Screen off, audio keeps playing" |
*
* @param {Funnel_Ob_Ben_Eyes_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_eyes_note = /** @type {((inputs?: Funnel_Ob_Ben_Eyes_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Eyes_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_eyes_note(inputs)
	return en_funnel_ob_ben_eyes_note(inputs)
});